<script module>
  export const meta = {
    title: 'Product',
    teaser:
      'Pausly is packed with features that go beyond what you initially see. Dive into\neverything Pausly has to offer.',
    sort: 1,
  }
</script>
